// extracted by mini-css-extract-plugin
export default {"container__configurator":"configurator_container__configurator__sbJV4","title":"configurator_title__BTTUR"};